import { PatientDetailScreen } from "~/session/patient-detail/patient-detail-screen";

// /session/:id/patient/:patientId — a single patient's handover detail (E5.2).
// Thin route wrapper; the screen reads the session from context and the patient
// id from the URL.
export default function PatientDetailRoute(): JSX.Element {
  return <PatientDetailScreen />;
}
